import React, {useState} from 'react';
import { withStyles } from "@mui/styles";
import {Dialog, DialogContent, DialogTitle, IconButton, Switch, Typography, useMediaQuery} from '@mui/material';
import {connect} from "trim-redux";
import {useTranslation} from "react-i18next";
import {Close} from "@mui/icons-material";
import {Styles} from "../../../../../config/design/styles";
import Button from "@mui/material/Button";
import {currencySymbol, getMediaURL, price} from "../../../../../config/values";
import {BriefcaseBusiness, PanelTopOpen, Wallet} from "lucide-react";
import Grid from "@mui/material/Grid2";
import LoadingButton from "../../../../components/elements/LoadingButton";
import axios from "axios";
import {defaultVariables} from "../../../../../config";
import {useLocation, useNavigate} from "react-router-dom";
import Box from "@mui/material/Box";
import NumberField from "../../../../components/elements/fields/NumberField";

function DonateButton({item,classes,isAuth,user }) {
    const { t } = useTranslation();
    const [open,setOpen] = useState(false);
    const [amount,setAmount] = useState(null);
    const [submitLoading, setSubmitLoading] = useState(false);
    const navigation = useNavigate();
    const location = useLocation();
    const [consumeCharge, setConsumeCharge] = useState(false);
    const isPanelIconVisible = useMediaQuery('(min-width:600px) and (max-width:700px)');

    const handleRequest = async () => {
        setSubmitLoading(true);
        const data = new FormData();
        data.append('charity_id', item.id);
        data.append('amount', amount);
        data.append('has_wallet', !!consumeCharge ? 1 : 0);

        const loginToken = localStorage.getItem('ACT');
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };

        try {
            const response = await axios.post(`${defaultVariables.url}/charities/donate`, data, config);
            let res = response.data;
            localStorage.setItem("payment_redirect_url", `/charities`);
            localStorage.setItem("payment_redirect_text", t('viewLatestDonates'));
            navigation(`/account/transaction/${res.unique_code}`);
            setSubmitLoading(false);
            setOpen(false);
        } catch (error) {
            console.error(error);
            setSubmitLoading(false);
        }
    }
    const handleLogin = () => {
        localStorage.setItem("redirect", location.pathname);
        navigation('/login');
    }
    return (
        <>
            <Button
                onClick={() => setOpen(true)}
                startIcon={!isPanelIconVisible ? <PanelTopOpen className="lucide-sm" /> : null}
                color="secondary"
                variant="outlined"
                className="charity-btn-md"
            >
                <span  style={{fontSize:12}}>{t('donate')}</span>
            </Button>
            {
                !!isAuth ?
                    <Dialog  open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
                        <DialogTitle className="dialog-title">
                            {t('donate')}
                            <IconButton
                                onClick={() => setOpen(false)}
                                style={{position:"absolute",right:15,top:15}}
                                size="small"
                            >
                                <Close className="lucide-icon"/>
                            </IconButton>
                        </DialogTitle>
                        <DialogContent>
                            <Grid container spacing={2}>
                                <Grid item size={12}>
                                    <Box>
                                        <div className="flex-direction">
                                            <img className="charity-logo" src={getMediaURL(item.file,'small')} alt={item.name} style={{width:70}}/>
                                            <div>
                                                <Typography align="left" className="bold mb-10">
                                                    {item.name}
                                                </Typography>
                                                <div className="flex-direction">
                                                    <BriefcaseBusiness className="lucide-small-narrow"/>
                                                    <span>{item.activity_field}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </Box>

                                    <div className="my-15">
                                        <span className="charity-desc">{item.description}</span>
                                    </div>
                                </Grid>
                                <Grid item size={12}>
                                    <div className='donate-holder'>
                                        <Grid container spacing={2}>
                                            <Grid item size={12}>
                                                <NumberField
                                                    fullWidth
                                                    label={t('amount')}
                                                    variant="outlined"
                                                    value={amount}
                                                    endAdornment={currencySymbol}
                                                    decimals={2}
                                                    min={0}
                                                    onChange={(res) => setAmount(res)}
                                                />
                                            </Grid>
                                            {
                                                (!!user.wallet.amount && amount > 0) &&
                                                <Grid item size={12}>
                                                    <div className="flex-space paymentItem">
                                                        <div className="flex-direction">
                                                            <Wallet className="lucide-icon-text"></Wallet>
                                                            <div className="flex-direction flex-column-md gap-0">
                                                                <Typography><strong>{t('useWallet')}</strong></Typography>
                                                                <Typography>({price(user.wallet.amount)} {currencySymbol})</Typography>
                                                            </div>
                                                        </div>
                                                        <Switch
                                                            checked={consumeCharge}
                                                            color="secondary"
                                                            onChange={() => setConsumeCharge(!consumeCharge)}
                                                        />
                                                    </div>
                                                </Grid>
                                            }
                                            <Grid item size={12}>
                                                <LoadingButton
                                                    className="confirm-btn"
                                                    variant="contained"
                                                    color="secondary"
                                                    onClick={() => handleRequest()}
                                                    loading={submitLoading}
                                                    disabled={!amount}
                                                >
                                                    {t("donate")}
                                                </LoadingButton>
                                            </Grid>
                                        </Grid>
                                    </div>
                                </Grid>
                            </Grid>
                        </DialogContent>
                    </Dialog>
                    :
                    <Dialog  open={open} onClose={() => setOpen(false)} fullWidth maxWidth="xs">
                        <DialogTitle className="dialog-title">
                            {t('donate')}
                            <IconButton
                                onClick={() => setOpen(false)}
                                style={{position:"absolute",right:15,top:15}}
                                size="small"
                            >
                                <Close className="lucide-icon"/>
                            </IconButton>
                        </DialogTitle>
                        <DialogContent>
                            <Typography className="my-20">{t('loginToDoThis')}</Typography>
                            <Button
                                onClick={() => handleLogin()}
                            >
                                {t('login')}
                            </Button>
                        </DialogContent>
                    </Dialog>

            }
        </>

    );
}
const mapStateToProps = (state) => ({
    isAuth: state.isAuth,
    user: state.user,
});

export default withStyles(Styles)(connect(mapStateToProps)(DonateButton));
